import React from "react";
import DarkwebIntelligenceCenter from "./darkweb/DarkwebIntelligenceCenter";

const Darkweb = () => <DarkwebIntelligenceCenter />;

export default Darkweb;
